<template>
    <div class="ar-player">
        <div class="actions">
            <!-- <icon-button
                class="download icon"
                name="download"
                @click.native="decorator(download)"/> -->

            <icon-button
                :name="playBtnIcon"
                :class="{'icon play2 active': isPlaying}"
                class="icon play2"
                @click.native="decorator(playback)"
            />

            <!-- <uploader
                :record="record"
                :options="uploaderOptions"
                class="icon"/> -->
        </div>

        <div class="bar">
            <div class="time">{{ playedTime }}</div>
            <line-control
                :percentage="progress"
                class="progress"
                ref-id="progress"
                @change-linehead="_onUpdateProgress"
            />
            <div class="time">{{ duration }}</div>
            <!-- <volume-control @change-volume="_onChangeVolume"/> -->
        </div>

        <audio
            :id="playerUniqId"
            :src="audioSource"
        />
    </div>
</template>

<script>
import IconButton from './icon-button';
import LineControl from './line-control';
import Uploader from './uploader';
import VolumeControl from './volume-control';
import { convertTimeMMSS } from './lib/utils';

export default {
    store: ['api'],
    components: {
        IconButton,
        LineControl,
        Uploader,
        VolumeControl
    },
    props: {
        src: { type: String, default: '' },
        record: { type: Object, default: () => new Object() },
        compact: { type: Boolean, default: true },
        uploaderOptions: { type: Object, default: () => new Object() }
    },
    data () {
        return {
            isPlaying: false,
            duration: convertTimeMMSS(0),
            playedTime: convertTimeMMSS(0),
            progress: 0,
            media: false
        };
    },
    computed: {
        audioSource () {
            let url = this.src || this.record.url;
            if (url) {
                return url;
            } else {
                this._resetProgress();
            }
        },
        playBtnIcon () {
            return this.isPlaying ? 'pause' : 'play';
        },
        playerUniqId () {
            return `audio-player${this._uid}`;
        }
    },
    mounted: function () {
        this.player = document.getElementById(this.playerUniqId);

        this.player.addEventListener('ended', () => {
            this.isPlaying = false;
        });

        this.player.addEventListener('loadeddata', () => {
            this._resetProgress();
            this.duration = convertTimeMMSS(this.player.duration);
        });

        this.player.addEventListener('timeupdate', this._onTimeUpdate);

        this.$events.$on('remove-record', () => {
            this._resetProgress();
        });

        this.$events.$on('do-upload-story', id => {
            if (pgap) {
                var fileURL = this.src || this.record.url;
                console.log('upload', fileURL);
                fileURL = fileURL.replace('documents://', cordova.file.documentsDirectory);
                console.log('upload2', fileURL);
                var options = new FileUploadOptions();
                options.fileKey = 'file';
                options.fileName = fileURL.substr(fileURL.lastIndexOf('/') + 1);
                options.mimeType = 'audio/wav';
                options.chunkedMode = false;
                options.headers = {
                    uuid: localStore.getItem('uuid'),
                    jwt: localStore.getItem('jwt')
                };
                options.params = {
                    type: 'submission',
                    uploadType: 'audio',
                    submissionId: id
                };
                var ft = new FileTransfer();
                ft.upload(
                    fileURL,
                    `https://${pgap ? 'getcoral.app' : location.hostname}/api/attachments`,
                    function (data) {
                        console.log('upload success', data);
                    },
                    function (e) {
                        console.log('upload error', e);
                    },
                    options,
                    true
                );
                ft.onprogress = function (progressEvent) {
                    console.log('onprogress: ' + (progressEvent.loaded / progressEvent.total) * 100 + '%');
                };
            } else {
                const data = new FormData();
                if (this.record.blob) {
                    data.append('file', this.record.blob, 'my-record');
                }
                data.set('type', 'submission');
                data.set('uploadType', 'audio');
                data.set('submissionId', id);
                f7.preloader.show();
                this.$http
                    .post(`${this.api}/attachments`, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(
                        () => {
                            f7.preloader.hide();
                            // f7.dialog.alert('Uploaded audio!');
                        },
                        errorResponse => {
                            console.log('Upload response error occurred: ', errorResponse);
                            f7.preloader.hide();
                            f7.dialog.alert(errorResponse.body.message || 'Something went wrong during audio upload');
                        }
                    );
            }
        });
    },
    methods: {
        setMedia: function (url) {
            this.media = new Media(
                url,
                () => {
                    console.log('playAudio():Audio Success');
                },
                // error callback
                err => {
                    console.log('playAudio():Audio Error: ' + err.code);
                }
            );
            console.log('media set', this.media);
            window.m = this.media;
        },
        playback: function () {
            if (this.isPlaying && this.media) {
                if (pgap) {
                    this.media.pause();
                } else {
                    this.player.pause();
                }
            } else {
                if (pgap) {
                    //if (!this.media) {
                    this.setMedia(this.src || this.record.url);
                    //}
                    setTimeout(() => {
                        this.media.play();
                    }, 0);
                } else {
                    setTimeout(() => {
                        this.player.play();
                    }, 0);
                }
            }

            this.isPlaying = !this.isPlaying;
        },
        download () {
            let link = document.createElement('a');
            link.href = this.record.url;
            link.download = 'record.wav';
            link.click();
        },
        decorator (func) {
            if (!this.audioSource) {
                return;
            }
            func();
        },
        _resetProgress () {
            if (this.isPlaying) {
                this.player.pause();
            }

            this.duration = convertTimeMMSS(0);
            this.playedTime = convertTimeMMSS(0);
            this.progress = 0;
            this.isPlaying = false;
        },
        _onTimeUpdate () {
            this.playedTime = convertTimeMMSS(this.player.currentTime);
            this.progress = (this.player.currentTime / this.player.duration) * 100;
        },
        _onUpdateProgress (pos) {
            if (pos) {
                this.player.currentTime = pos * this.player.duration;
            }
        },
        _onChangeVolume (val) {
            if (val) {
                this.player.volume = val;
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
</style>
